import * as vimeo from '../utils/vimeo';

let Glide = null;

const AutoBullets = function (Glide, Components, Events, classes) {
  const NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
  let bullets = null;
  let siblings = null;

  const Component = {
      async mount() {         
          if(!siblings) {
            siblings = (await import('@glidejs/glide/src/utils/dom')).siblings;
          }

          bullets = Components.Html.root.querySelector(
            NAV_SELECTOR
          );

          if(!bullets) return;

          this.render();
      },

      render() {
        const { startAt, perView, classes } = Glide._o;
        const totalSlides = Components.Html.slides.length;
        const pageCount = Math.ceil(totalSlides / perView);
        const fragment = document.createDocumentFragment();
          
        for (let index = 0; index < pageCount; index++) {
          const button = document.createElement('button');
            button.classList.add(classes.nav.default);
            
            if( index === startAt ) {
              button.classList.add(classes.nav.active);
            }

            button.setAttribute('data-glide-dir', '=' + perView * index);
            button.ariaLabel = index + 1;
            fragment.appendChild(button);
        }
        
        bullets.innerHTML = '';
        bullets.appendChild(fragment);

        Components.Controls.addBindings();
      },

      setActive() {
        const bullet = bullets.querySelector(`[data-glide-dir^="=${Glide.index}"]`);
        bullet.classList.add(Glide.settings.classes.nav.active);
        
        siblings(bullet).forEach(sibling => {
          sibling.classList.remove(Glide.settings.classes.nav.active);
        });
      },
  };

  Events.on('run', () => {
    Component.setActive();
  });

  Events.on('resize', () => {
    Component.render();
  });

  return Component;
};

const VideoSlides = function (Glide, Components, Events, classes) {
  const VIDEO_SELECTOR = '[data-video-id]';
  const PLAYER_SETTINGS = {
    color: 'f39200'
  };
  const players = [];

  const Component = {
      async mount() {
        const { slides } = Components.Html;

        slides.forEach(slide => {
          const container = slide.querySelector(VIDEO_SELECTOR);
          if( container ) {
            const { videoId } = container.dataset;
            const embed = vimeo.generateEmbed(videoId, {
              id: videoId,
              muted: true,
              loop: true,
              controls: false,
              ...PLAYER_SETTINGS
            });
            embed.isInitialised = false;
            embed.addEventListener('load', () => embed.isLoaded = true );
            players.push({ container, embed });
          } else {
            players.push(null);
          }
        })

        this.play();
      },

      pause() {
        if(players[Glide.index]) {
          const player = players[Glide.index];
          vimeo.pause(player.embed);
        }
      },

      play() {
        if(players[Glide.index]) {
          const player = players[Glide.index];

          if( !player.embed.isInitialised ) {
            player.container.replaceChildren(player.embed);
            player.embed.isInitialised = true;
          }

          if( player.embed.isLoaded ) {
            vimeo.play(player.embed);
          }
        }
      },
  };

  Events.on('run.before', () => {
    Component.pause();
  });

  Events.on('run', () => {
    Component.play();
  });

  return Component;
};

const Fullscreen = function (Glide, Components, Events, classes) {
  const FULLSCREEN_BUTTON_SELECTOR = '.Gallery-fullscreen';
  const FULLSCREEN_CONTENT_SELECTOR = '.Gallery-main';
  let fullscreenButton = null;
  let fullscreenContent = null;

  const Component = {
      async mount() {

          fullscreenButton = Components.Html.root.querySelector(
            FULLSCREEN_BUTTON_SELECTOR
          );

          fullscreenContent = Components.Html.root.querySelector(
            FULLSCREEN_CONTENT_SELECTOR
          );

          if(!fullscreenButton || !fullscreenContent) return;

          this.render();
      },

      render() {
        fullscreenButton.addEventListener('click', () => {
          if( document.fullscreenElement ) {
            this.exitFullscreen();
          } else {
            this.goFullscreen();
          }
        });

        Components.Controls.addBindings();
      },

      goFullscreen() {
        if (fullscreenContent.requestFullscreen) {
          fullscreenContent.requestFullscreen();
        } else if (fullscreenContent.mozRequestFullScreen) { // Firefox
          fullscreenContent.mozRequestFullScreen();
        } else if (fullscreenContent.webkitRequestFullscreen) { // Chrome, Safari and Opera
          fullscreenContent.webkitRequestFullscreen();
        } else if (fullscreenContent.msRequestFullscreen) { // IE/Edge
          fullscreenContent.msRequestFullscreen();
        }
      },

      exitFullscreen() {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) { // Firefox
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) { // Chrome, Safari, Opera
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { // IE/Edge
          document.msExitFullscreen();
        }
      },
  };

  return Component;
};

async function init(element){
  if(!Glide) {
    Glide = (await import('@glidejs/glide')).default;
  }

  new Glide( element, {
    type: 'slider',
    perView: 1,
    perSwipe: '|',
    gap: 20,
    classes: {
      type: {
        slider: 'Gallery--init',
        carousel: 'Gallery--init'
      },
      direction: {
        ltr: 'Gallery--ltr',
        rtl: 'Gallery--rtl'
      },
      swipeable: 'Gallery--swipeable',
      dragging: 'Gallery--dragging',
      nav: {
        default: 'Gallery-navItem',
        active: "is-active"
      },
      slide: {
        active: 'is-active',
        clone: 'Gallery-slide--clone'
      },
      arrow: {
        disabled: 'is-disabled'
      }
    }
  }).mount({
    AutoBullets,
    VideoSlides,
    Fullscreen
  });
}

window.addEventListener('load', () => {
  document.querySelectorAll('.js-Gallery').forEach( element => init(element))
});